module.exports = __webpack_public_path__ + "components/flag/static/square/fo-1d166a635319c437815b0e111cf1fc03.svg";